// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RollbackEmployeePayModal__wrap--29VYD"};